module.exports = __webpack_public_path__ + "static/img/Gloria2018.7ca8b62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bssp/Gloria2018.jpg
// module id = 129
// module chunks = 2